module.exports = __webpack_public_path__ + "img/TheGoldenOwlofAthena.2e0bc86e.png";